const foods=[
    
    {
        catagory:'Breakfast',
        id:1,
        title:'Toasted English Muffin',
        item:'https://i.ibb.co/qdV3Zzp/breakfast1.png',
        detail:'Awesome food',
        description:'A rich gravy made of khus khus, coconut and milk that tastes best with koftas made from khoya. This velvety and creamy recipe will leave you licking your fingers. Makhmali kofte can be your go-to dish for dinner parties as this is quite different from other kofta recipes and extremely delicious.',
        price:55,
        quantity:1},
        {catagory:'Breakfast',
        id:2,
        description:'A rich gravy made of khus khus, coconut and milk that tastes best with koftas made from khoya. This velvety and creamy recipe will leave you licking your fingers. Makhmali kofte can be your go-to dish for dinner parties as this is quite different from other kofta recipes and extremely delicious.',
        title:'Bagel with Cream Cheese',
        item:'https://i.ibb.co/KGSsptM/breakfast2.png',
        detail:'Awesome food',
        price:15,
        quantity:1},
        {
        catagory:'Breakfast',
        id:3,
        quantity:1,
        description:'A rich gravy made of khus khus, coconut and milk that tastes best with koftas made from khoya. This velvety and creamy recipe will leave you licking your fingers. Makhmali kofte can be your go-to dish for dinner parties as this is quite different from other kofta recipes and extremely delicious.',
        title:'Cinnamon Rolls',
        item:'https://i.ibb.co/Tw8Qqmm/breakfast3.png ',
        detail:'Awesome food',
        price:8},
        {
        catagory:'Breakfast',
        id:4,
        quantity:1,
        description:'A rich gravy made of khus khus, coconut and milk that tastes best with koftas made from khoya. This velvety and creamy recipe will leave you licking your fingers. Makhmali kofte can be your go-to dish for dinner parties as this is quite different from other kofta recipes and extremely delicious.',
        title:'Belgian Style Waffles',
        item:'https://i.ibb.co/BN0YpJG/breakfast4.png',
        detail:'Awesome food',
        price:50},
        {
        catagory:'Breakfast',
        id:5,
        quantity:1,
        description:'A rich gravy made of khus khus, coconut and milk that tastes best with koftas made from khoya. This velvety and creamy recipe will leave you licking your fingers. Makhmali kofte can be your go-to dish for dinner parties as this is quite different from other kofta recipes and extremely delicious.',
        title:'Breakfast Burrito',
        item:'https://i.ibb.co/94Nb0kk/breakfast5.png',
        detail:'Awesome food',
        price:15},
        {
        catagory:'Breakfast',
        id:6,
        quantity:1,
        description:'A rich gravy made of khus khus, coconut and milk that tastes best with koftas made from khoya. This velvety and creamy recipe will leave you licking your fingers. Makhmali kofte can be your go-to dish for dinner parties as this is quite different from other kofta recipes and extremely delicious.',
        title:'Breakfast Parfait',
        item:'https://i.ibb.co/vxXXtNS/breakfast6.png',
        detail:'Awesome food',
        price:14,
        
    },
    {
        catagory:'Dinner',
        id:7,
        quantity:1,
        description:'A rich gravy made of khus khus, coconut and milk that tastes best with koftas made from khoya. This velvety and creamy recipe will leave you licking your fingers. Makhmali kofte can be your go-to dish for dinner parties as this is quite different from other kofta recipes and extremely delicious.',
        title:'Lemon Chicken ',
        item:'https://i.ibb.co/Z8ZRWbF/dinner1.png',
        detail:'Awesome food',
        price:41},
        {catagory:'Dinner',
        id:8,
        quantity:1,
        description:'A rich gravy made of khus khus, coconut and milk that tastes best with koftas made from khoya. This velvety and creamy recipe will leave you licking your fingers. Makhmali kofte can be your go-to dish for dinner parties as this is quite different from other kofta recipes and extremely delicious.',
        title:'Chettinad Fish Fry',
        item:'https://i.ibb.co/MZzH358/dinner2.png',
        detail:'Awesome food',
        price:5},
        {
         catagory:'Dinner',
         id:9,
         quantity:1,
         title:'Guilt-Free Galouti Kebab  ',
        item:'https://i.ibb.co/XYvzrbD/dinner3.png',
        detail:'Awesome food',
        price:47},
        {
        catagory:'Dinner',
        id:10,
        quantity:1,
        description:'A rich gravy made of khus khus, coconut and milk that tastes best with koftas made from khoya. This velvety and creamy recipe will leave you licking your fingers. Makhmali kofte can be your go-to dish for dinner parties as this is quite different from other kofta recipes and extremely delicious.',
        title:'Dum Aloo Lakhnawi',
        item:'https://i.ibb.co/7tDZrjj/dinner4.png',
        detail:'Awesome food',
        price:41},
        {
         catagory:'Dinner',
         title:'Keema Biryani',
         id:11,
         quantity:1,
         description:'A rich gravy made of khus khus, coconut and milk that tastes best with koftas made from khoya. This velvety and creamy recipe will leave you licking your fingers. Makhmali kofte can be your go-to dish for dinner parties as this is quite different from other kofta recipes and extremely delicious.',
        item:'https://i.ibb.co/gwBTWv2/dinner5.png',
        detail:'Awesome food',
        price:13},
        {
        catagory:'Dinner',
        id:12,
        quantity:1,
        description:'A rich gravy made of khus khus, coconut and milk that tastes best with koftas made from khoya. This velvety and creamy recipe will leave you licking your fingers. Makhmali kofte can be your go-to dish for dinner parties as this is quite different from other kofta recipes and extremely delicious.',
        title:'Dum Paneer Kali Mirch',
        item:'https://i.ibb.co/PWt44G6/dinner6.png',
        detail:'Awesome food',
        price:14,
        
    },
    {
        catagory:'Lunch',
        id:13,
        quantity:1,
        description:'A rich gravy made of khus khus, coconut and milk that tastes best with koftas made from khoya. This velvety and creamy recipe will leave you licking your fingers. Makhmali kofte can be your go-to dish for dinner parties as this is quite different from other kofta recipes and extremely delicious.',
        title:'Shahi Egg Curry',
        item:'https://i.ibb.co/rcv3T5G/lunch1.png',
        detail:'Awesome food',
        price:15},
        {catagory:'Lunch',
        id:14,
        quantity:1,
        description:'A rich gravy made of khus khus, coconut and milk that tastes best with koftas made from khoya. This velvety and creamy recipe will leave you licking your fingers. Makhmali kofte can be your go-to dish for dinner parties as this is quite different from other kofta recipes and extremely delicious.',
        title:'Malabari Prawn Curry',
        item:'https://i.ibb.co/gMF9sJ6/lunch2.png',
        detail:'Awesome food',
        price:47},
        {
         catagory:'Lunch',
         id:15,
         quantity:1,
         description:'A rich gravy made of khus khus, coconut and milk that tastes best with koftas made from khoya. This velvety and creamy recipe will leave you licking your fingers. Makhmali kofte can be your go-to dish for dinner parties as this is quite different from other kofta recipes and extremely delicious.',
         title:'Makhmali Kofte',
        item:'https://i.ibb.co/mFkkFtf/lunch3.png ',
        detail:'Awesome food',
        price:18},
        {
         catagory:'Lunch',
         id:16,
         quantity:1,
         description:'A rich gravy made of khus khus, coconut and milk that tastes best with koftas made from khoya. This velvety and creamy recipe will leave you licking your fingers. Makhmali kofte can be your go-to dish for dinner parties as this is quite different from other kofta recipes and extremely delicious.',
         title:' Dal Makhani',
        item:'https://i.ibb.co/9hXVBvp/lunch4.png',
        detail:'Awesome food',
        price:17},
        {
         catagory:'Lunch',
         id:17,
         quantity:1,
         description:'A rich gravy made of khus khus, coconut and milk that tastes best with koftas made from khoya. This velvety and creamy recipe will leave you licking your fingers. Makhmali kofte can be your go-to dish for dinner parties as this is quite different from other kofta recipes and extremely delicious.',
         title:'Mutton Do Pyaaza',
        item:'https://i.ibb.co/894C2b1/lunch5.png',
        detail:'Awesome food',
        price:32},
        {
        catagory:'Lunch',
        id:18,
        quantity:1,
        description:'A rich gravy made of khus khus, coconut and milk that tastes best with koftas made from khoya. This velvety and creamy recipe will leave you licking your fingers. Makhmali kofte can be your go-to dish for dinner parties as this is quite different from other kofta recipes and extremely delicious.',
        title:'Ajwaini Paneer Kofta Curry ',
        item:'https://i.ibb.co/f4Dt4m4/lunch6.png',
        detail:'Awesome food',
        price:14,
        
    },
]
export default foods